import React from 'react'
import EbookData from '../ebook.json'
import ServerInfo from '../server.json'
import HorizontalList from '../common/HorizontalList'
import '../App.css';
import { Card, CardSection } from '../common'
import Ebook from '../common/Ebook'
import ShowBooks from '../common/ShowBooks'
import HeaderBar from '../common/HeaderBar'
import BottomBar from '../common/BottomBar'
import {connect } from 'react-redux'
import axios from 'axios'
import * as geolib from 'geolib'

class Library extends React.Component {
    state = {
        isIframeOpen: false,
        epubIframeLink: 'epub_content/epubfile',
        ipAddress: ServerInfo.ipAddress,
        category: ServerInfo.category,
        selection: 'overview',
        categorySelected: '',

        overviewSelectedStyle: {},
        categoriesSelectedStyle: {},
        style1: {},

        epubData:EbookData,
    };

    

    /*constructor(){
        super();
        this.handleIncrement = this.handleIncrement.bind(this);
    }*/
    // componentDidMount()
    // {
    //     // console.log(this.props)
    //     // this.setState({overviewSelectedStyle: this.selected, categoriesSelectedStyle: this.selection})

    //     // // var self = this
    //     // axios({
    //     //     method: 'get',
    //     //     url: 'http://localhost:8080/content/getSubCategory/ContentbyMainId/149',
    //     //     responseType: 'stream'
    //     // })
    //     // .then(response => {
    //     //     // console.log(response.data)

    //     //     var tempData = response.data
    //     //     var getList=[]

    //     //     for(var i = 0 ; i< tempData.length ; i++)
    //     //     {
    //     //         if(tempData[i].contentSubCategory.contentType == "EPUB")
    //     //         {
    //     //             getList.push(tempData[i])
    //     //         }
    //     //     }

    //     //     this.setState({
    //     //         epubData : getList
    //     //     })

    //     //     console.log(this.state.epubData)

            
    //     // })
    //     // .catch(error => {
    //     //     console.log(error)
    //     // })
    // }

    render() {

        // if(this.state.selection == 'overview')
        // {
            
            return(                          
                <Card>
                    <HeaderBar history={this.props.history}></HeaderBar>
                    
                    {
                        this.renderOverview()
                        //this.test()
                    }
    
                    <BottomBar history={this.props.history}></BottomBar>
                </Card>
            )
        // }
        
        // if(this.state.selection == 'categories')
        // {
        //     return(                          
        //         <Card>
        //             <HeaderBar history={this.props.history}></HeaderBar>
                    
        //             {
        //                 this.renderCategories()
        //             }
    
        //             <BottomBar history={this.props.history}></BottomBar>
        //         </Card>
        //     )
        // }
        
    }
    
    renderOverview()
    {
        return (
            <div style={{padding: '80px 10px 100px 10px'}}>                  
                
                {/* {this.renderSelection()} */}

                {/* <CardSection>
                    <img 
                        style={{width: "100%"}}
                        src={ServerInfo.frontBanner}
                        resizemode={"contain"}
                        alt=''
                    />
                    <hr style={this.divider}/>
                </CardSection> */}

                {
                    this.state.category.map((item,index) =>(
                    <div key = {index}>
                        <p style={this.categoryName}>{item}</p>
                        <HorizontalList
                        ebooksData={EbookData}
                        libraryProps={this.props}
                        category={item}
                        />
                        <br/>
                    </div>
                    ))
                }
                </div>
                // category={item}
        )
    }

    // renderSelection()
    // {
    //     return(
    //         <CardSection style={{flexDirection: 'column', }}>
    //             <div style={this.titlePageContainer}>
    //                 <div>
    //                     <h1 style={{marginBottom: 5}}>Epub Library</h1>
    //                     <p style={{fontWeight: 600, color: 'grey', marginTop: 0, marginBottom: 25}}>Find your next favorite book</p>
    //                 </div>
    //             </div>
                
    //             <div>
    //                 <span onClick={() => this.changeRenderView('overview')} style={this.state.overviewSelectedStyle}>OVERVIEW</span>
    //                 <span onClick={() => this.changeRenderView('categories')} style={this.state.categoriesSelectedStyle}>CATEGORIES</span>
    //             </div>
                
    //         </CardSection>
    //     )
    // }

    // renderCategories()
    // {
    //     return (
    //         <div style={{padding: '80px 10px'}}>

    //             {this.renderSelection()}

    //             <hr style={this.divider}/>
    //             <div style={{padding: '0px 0px 20px 30px'}}>
    //                 <span onClick={()=> this.categorySelected('')} style={this.state.style1}>Categories </span>
    //                 >
    //                 <span> {this.state.categorySelected}</span> 
    //             </div>
                
    //             {this.renderBookInCategories()}
    //         </div>
    //     )
    // }

    // renderBookInCategories()
    // {
    //     if(this.state.categorySelected != '')
    //     {
    //         var tempBookList = []
    //         for(var i=0; i<EbookData.length; i++)
    //         {
    //             if(EbookData[i].category == this.state.categorySelected)
    //             {
    //                 tempBookList.push(EbookData[i])
    //             }
    //         }
    //         return(
    //             <ShowBooks
    //             bookArray = {tempBookList}
    //             libraryProps={this.props}/>
    //         )
    //     }

    //     else
    //     {
    //         return(
    //             <div>
    //                 {
    //                 this.state.category.map((item,index) =>(
    //                     <li onClick={() => this.categorySelected(item)} key = {index} style={this.categoryDisplay}>
    //                         {item}
    //                     </li>
    //                     ))
    //                 }
    //             </div>
    //         )
    //     }
    // }

    // changeRenderView(value)
    // {
    //     this.setState({selection: value})
    //     if (value == 'overview')
    //     {
    //         this.setState({overviewSelectedStyle: this.selected})
    //         this.setState({categoriesSelectedStyle: this.selection})
    //     }

    //     else if (value == 'categories')
    //     {
    //         this.setState({overviewSelectedStyle: this.selection})
    //         this.setState({categoriesSelectedStyle: this.selected})
    //     }
    // }

    // categorySelected(category)
    // {
    //     this.setState({categorySelected: category})
    //     if(category != '')
    //     {
    //         this.setState({style1: {fontWeight: 700, cursor: 'pointer'}})
    //     }
    //     else
    //     {
    //         this.setState({style1: {}})
    //     }
        
    // }

    // test = () =>
    // {
    //     console.log('http://10.0.0.148:8080/epub_content/ebook.json')
    //     fetch('http://10.0.0.148:8080/epub_content/ebook.json', { mode: 'no-cors'})
    //     .then(
    //         function(response) {
    //         if (response.status !== 200) {
    //             console.log('Looks like there was a problem. Status Code: ' +
    //             response.status);
    //             return;
    //         }

    //         // Examine the text in the response
    //         response.json().then(function(data) {
    //             console.log(data);
    //         });
    //         }
    //     )
    //     .catch(function(err) {
    //         console.log('Fetch Error :-S', err);
    //     });
        
    // }

    //Styles
    closeBtn = {
        fontSize: 20,
        padding: 10,
        margin: 'auto'
    }

    selection = {
        color: 'black',
        padding: '15px 25px 15px 0px',
        display: 'inline-block',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 650,
    }

    selected= {
        color: 'black',
        padding: '15px 25px 15px 0px',
        display: 'inline-block',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 650,
        // textDecoration: 'underline',
        border: 'solid #ccc',
    }

    categoryName = 
    {
        fontSize: '18px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 0,
        margin: 0,
    }
    
    titlePageContainer =
    {
        height: 116,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }

    divider =
    {
        margin: '20px 10px',
        borderTop: '2px solid #e9edf8'
    }

    categoryDisplay = 
    {
        cursor: 'pointer',
        color: '#1c263d',
        padding: '4px 4px'
    }
}

export default connect(state => state)(Library)